import { memo, useCallback } from "react";

// UI
import { CardSelect } from "ui/components/CardSelect";
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import { ContactDropdownTypeEnum } from "ui/components/Dropdown/ContactDropdown/types";
import UserDropdown from "ui/components/Dropdown/UserDropdown/UserDropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

// Servisni sloj
import { DriverSourceEnum } from "services/api/fleet/vehicles/drivers/types";

import { DRIVER_SOURCE_OPTIONS } from "../../consts";
import { DriverPersonFormProps } from "./types";

/**
 * Prvi korak unosa vozača — tko je vozač. Iza vozača stoji korisnik aplikacije ili kontakt
 * iz imenika; odluka se donosi ovdje, pa je ostatak aplikacije ne mora poznavati.
 */
const DriverPersonForm: React.FC<DriverPersonFormProps> = (props) => {
  const { values, errors, onChange, source, onSourceChange } = props;

  // Promjena izvora briše ono što je došlo od prethodnog — vozač je jedno ili drugo.
  const handleSourceChange = useCallback(
    (id: string) => {
      onSourceChange(id as DriverSourceEnum);
      onChange({ ...values, contactId: null, userId: null });
    },
    [values, onChange, onSourceChange]
  );

  const handleUserChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onChange({ ...values, userId: item.value || null, contactId: null });
    },
    [values, onChange]
  );

  const handleContactChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onChange({ ...values, contactId: item.value || null, userId: null });
    },
    [values, onChange]
  );

  return (
    <div className="flex items-start justify-center px-4 pt-12 pb-6">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-2">Vozač</h1>
        <p className="text-center text-md text-slate-500 mb-8">
          Odaberite tko vozi, netko od korisnika aplikacije ili kontakt.
        </p>

        <div className="border bg-white border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
                Osoba
              </h3>
              <p className="text-xs text-slate-500">
                Isprave se prilažu u sljedećim koracima
              </p>
            </div>

            <div className="flex flex-col ">
              <div className="mb-3">
                <CardSelect
                  options={DRIVER_SOURCE_OPTIONS}
                  value={source}
                  onChange={handleSourceChange}
                  columns={2}
                />
              </div>
              {source === DriverSourceEnum.USER ? (
                <UserDropdown
                  name="userId"
                  label="Korisnik"
                  placeholder="Odaberite korisnika"
                  value={values.userId}
                  onChange={handleUserChange}
                  error={errors.userId}
                  required
                  width="full"
                />
              ) : (
                <ContactDropdown
                  name="contactId"
                  label="Kontakt"
                  placeholder="Odaberite kontakt"
                  value={values.contactId}
                  onChange={handleContactChange}
                  error={errors.contactId}
                  required
                  width="full"
                  // Vozilo vozi osoba, ne tvrtka — popis i unos novog kontakta drže se osoba.
                  contactType={ContactDropdownTypeEnum.PERSON}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(DriverPersonForm);
